import { render } from "./step1.vue?vue&type=template&id=13e6610e&scoped=true"
import script from "./step1.vue?vue&type=script&lang=js"
export * from "./step1.vue?vue&type=script&lang=js"

import "./step1.vue?vue&type=style&index=0&id=13e6610e&scoped=true&lang=css"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e6610e"]])

export default __exports__